export interface Category {
  categoryId: number;
  categoryName: string;
  dateAdded?: Date;
  updatedAt?: Date;
  categoryDescription: string;
}

export const InitializeRoomCategoryData: Category = {
  categoryId: 0,
  categoryName: '',
  categoryDescription: '',
  dateAdded: new Date(),
  updatedAt: new Date()
};